import produce from "immer";
import { IStoreState } from "..";
import { LoadState } from "../../constants/enums";
import {
  CLEAR_LEDGER_STATE,
  defaultLedgerState,
  FETCH_LEDGER_LIST_FAILED,
  FETCH_LEDGER_LIST_PROGRESS,
  FETCH_LEDGER_LIST_SUCCESS,
  IPurchaseOrderActions,
} from ".";

export const ledgerReducer = (
  state: IStoreState["ledger"] = defaultLedgerState,
  action: IPurchaseOrderActions,
) => {
  switch (action.type) {
    case FETCH_LEDGER_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.ledger_list.loading = LoadState.InProgress;
        draftState.ledger_list.data = [];
        draftState.ledger_list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_LEDGER_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.ledger_list.loading = LoadState.Loaded;
        draftState.ledger_list.data = list;
        draftState.ledger_list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_LEDGER_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.ledger_list.loading = LoadState.InProgress;
        draftState.ledger_list.data = [];
        draftState.ledger_list.totalRecords = 0;
      });
      return newState;
    }

    case CLEAR_LEDGER_STATE: {
      return defaultLedgerState;
    }

    default: {
      return state;
    }
  }
};
